import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import FooterTopMenu from "core/Components/Footer/FooterTopMenu";

type Props = {
    footerTopMenu: [any] | undefined,
};

const FooterTopMenuBox: React.FC<Props> = ({ footerTopMenu }) => {
    const theme:Theme = useTheme();

    const style = css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-right: 35px;
        column-gap: 20px;
        row-gap: 10px;
        
        .footer--top_link_wrapper {
            &:not(:first-of-type) {
                column-gap: 50px;

                ${theme.breakpoints.only("sm")} {
                    column-gap: 32px;
                }

                ${theme.breakpoints.down("xs")} {
                    column-gap: 20px;
                }
            }
        }
        
        ${theme.breakpoints.down("md")} {
            padding-right: 0;
        }
    `;

    return (
        <div css={style}>
            {footerTopMenu?.map((menu: StandardPage) => (
                <FooterTopMenu key={"footerTopMenu" + menu.id} className={"footer--top_link_wrapper"} data={menu} />
            ))}
        </div>
    );
};

export default FooterTopMenuBox;